import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './homepage.js';
import Roadmap from './pages/roadmap.js';
import AnnouncementsPage from './pages/announcements.js';
import MediaPage from './pages/media.js';
import MediaDetailPage from './pages/media-detail.js';
import { AdminProvider } from './admin/AdminContext';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLayout from './admin/AdminLayout';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import AdminAnnouncements from './admin/AdminAnnouncements';
import AdminRoadmap from './admin/AdminRoadmap';
import AdminHomepage from './admin/AdminHomepage';
import AdminSocials from './admin/AdminSocials';
import AdminMedia from './admin/AdminMedia';
import './index.css';

function App() {
  return (
    <AdminProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/announcements" element={<AnnouncementsPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/media/:id" element={<MediaDetailPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="roadmap" element={<AdminRoadmap />} />
              <Route path="homepage" element={<AdminHomepage />} />
              <Route path="socials" element={<AdminSocials />} />
              <Route path="media" element={<AdminMedia />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;
